import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const style = css`
  .form-container {
    border-top: 1px solid ${colors.gray.shade46};
    margin: 0 8px 0 8px;
    padding-top: 2.4rem;
    @mixin mobileToTablet {
      border-top: none;
    }
    .button {
      display: flex;
      justify-content: center;
    }
    .form-title {
      margin-bottom: 2.4rem;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: ${colors.gray.shade15};
      @mixin mobileToTablet {
        margin-bottom: 1.2rem;
      }
    }
    .form-button {
      display: flex;
      justify-content: center;
      .box-button {
        max-width: 240px;
        width: 100%;
        display: flex;
      }
    }
  }
`;
export { style };
